<section class="irrigator-auth-panel" aria-labelledby="manager-auth-title">
  <button type="button" class="auth-back" (click)="backToProfileSelection()">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m15 18-6-6 6-6" />
    </svg>
    Volver
  </button>

  <div class="login-copy">
    <p class="login-kicker">Acceso de gestores</p>
    <h1 id="manager-auth-title">Autenticación de gestor</h1>
  </div>

  <form class="receipt-auth-form" (submit)="authenticateManager($event)">
    <label>
      <span>Usuario</span>
      <input
        type="text"
        name="username"
        [(ngModel)]="username"
        autocomplete="username"
        maxlength="200"
        required
      />
    </label>

    <label>
      <span>Contraseña</span>
      <input
        type="password"
        name="password"
        [(ngModel)]="password"
        autocomplete="current-password"
        maxlength="200"
        required
      />
    </label>

    @if (managerAuthError) {
      <p class="auth-error" role="alert">{{ managerAuthError }}</p>
    }

    <button type="submit" class="auth-submit" [disabled]="managerAuthLoading">
      {{ managerAuthLoading ? 'Comprobando...' : 'Acceder como gestor' }}
    </button>
  </form>
</section>
